import React, { Component, } from "react";
import Link from "@material-ui/core/Link";
import Multiselect from 'multiselect-react-dropdown';
import { Tabs, Tab, Dialog, DialogTitle, DialogContent, DialogActions, Autocomplete, TextField as MuiTextField } from '@mui/material';
import { toast } from "react-toastify";
import Reporting from "../../common/reporting";
import { Grid, Button, Typography, TextField } from '@material-ui/core';
import moment from "moment";
import "./tabbedProfile.css";
import { Progress, Academics, ActivitiesList, EventsList, Notes, PostSecondary, GeneralInfoForm, StudentProfileForm, StudentProfileFormPs, Progress2Exp } from "./components";
import AdvisorContext from "../context/context";
import { getUserAdvisorEventHistory, updateStudentProfile, getStudentById, getUserEventhistory, getUserMessageHistory, getUserChatHistory, getStudentSpecialGroups, getAdvisorListForPicker, overrideStudentAdvisor, clearStudentAdvisorOverride } from "../api.js";
import * as docApi from "../../api/documents";
import { eventType } from "../enums.js";
import LoadingIndicator from "../../common/loadingIndicator";
import enumHelper from "../../support/logic/enumHelper";
import { Language } from "../../admissions/logic/enums";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Export2PDF from "../../common/export";
import { StudentStatus } from "../../support/enums";
const languageOptions = enumHelper
    .getSelectOptionsList(Language);

const preSelectedReportFields = ["title", "description", "startTime", "endTime", "totalAvailableCreditHours", "type", "creator"];
const skippedFields = ["advisorEventTags","isDeleted", "deleterUserId", "deletionTime" ];

class AdvisorStudent extends Component {

    static contextType = AdvisorContext;

    constructor(props) {
        super(props);

        this.state = {


            activeProfile: this.props.profile,
            tab: 0,
            infoVis: "tabVisible",
            eventsVis: "tabHidden",
            activityVis: "tabHidden",
            postSecVis: "tabHidden",
            academicVis: "tabHidden",
            notesVis: "tabHidden",
            progressVis: "tabHidden",
            exportTitle: "",
            changed: false,
            description: "",
            activity: [],
            notes: [],
            events: [],
            messages: [],
            profileLoaded: false,
            ipedName: "",
            ipedFound: false,
            activityFiltered: [],
            titleList: [],
            creators: [],
            selCreators: [],
            selTitles: [],
            searchText: [],
            chats: [],
            specialGroups: [],

            // OWL-2291: manual advisor override
            advisorPickerList: [],
            reassignOpen: false,
            reassignAdvisor: null,
            reassignReason: "",
            reassignSaving: false,

        };
    }



    componentDidMount = async () => {
        let profileLoaded = false;

        const prof = await getStudentById(this.props.match.params.id)

        const histCall = await getUserAdvisorEventHistory(this.props.match.params.id);
        const messCall = await getUserMessageHistory(this.props.match.params.id);
        const history = histCall.data.result;

        const evtHistCall = await getUserEventhistory(this.props.match.params.id);

        const evtHist = evtHistCall.data.result;
        const activityFiltered = history.filter(flt => flt.type != eventType.StudentNote);
        const title = prof.data.result.userProfile.firstName + '-' + prof.data.result.userProfile.lastName + '-' + prof.data.result.studentProfile.crusaderId;
        const titleList = Array.from(new Map(activityFiltered.map(activity => [activity.title, { title: activity.title }])).values());
        const creatorList = Array.from(new Map(activityFiltered.map(activity => [activity.creator, { creator: activity.creator }])).values());
        const chats = await getUserChatHistory(this.props.match.params.id);

        let specialGroups = [];
        try {
            const sgCall = await getStudentSpecialGroups(this.props.match.params.id);
            specialGroups = sgCall.data.result || [];
        } catch (err) {
            specialGroups = [];
        }

        // OWL-2291: only Supervisor/Admin/Staff may reassign advisors; load the pickable advisor list.
        let advisorPickerList = [];
        if (this.canReassign()) {
            try {
                const advCall = await getAdvisorListForPicker(this.context.myBasics.userProfileId);
                advisorPickerList = (advCall.data.result || []).sort((a, b) =>
                    (a.displayName || "").localeCompare(b.displayName || ""));
            } catch (err) {
                advisorPickerList = [];
            }
        }
        this.setState({ advisorPickerList });

        this.setState({
            specialGroups,
            messages: messCall.data.result,
            exportTitle: title,
            activeProfile: prof.data.result,
            profileLoaded: true,
            activityFiltered,
            activity: activityFiltered,
            notes: history.filter(flt => flt.type == eventType.StudentNote),
            events: evtHist,
            titleList,
            creators: creatorList,
            chats: chats.data.result,

        });
        this.setState({ messages: messCall.data.result, exportTitle: title, activeProfile: prof.data.result, profileLoaded: true, activityFiltered: history.filter(flt => flt.type != eventType.StudentNote), activity: history.filter(flt => flt.type != eventType.StudentNote), notes: history.filter(flt => flt.type == eventType.StudentNote), events: evtHist, chats: chats.data.result });

    }
    componentDidUpdate(prevProps, prevState) {

        if (this.context.loaded && this.state.profileLoaded && this.state.ipedName == "" && this.state.activeProfile.studentProfile.institutionIPEDNo != null && !this.state.ipedFound) {

            let ipedName = "";


            const ipeds = this.context.ipedList.filter(flt => flt.ipedNo == this.state.activeProfile.studentProfile.institutionIPEDNo);
            if (ipeds.length == 1) {
                ipedName = ipeds[0].name;

            }
            this.setState({ ipedName: ipedName, ipedFound: true });
        }



    }

    getLanguage = (input) => {

        const lan = languageOptions.filter(l => l.value == input);
        return lan.length > 0 ? lan[0].label : "English";
    }
    toggleTitle = (list, newRec) => {
        this.setState(prevState => {
            const updatedList = prevState.selTitles.includes(newRec)
                ? prevState.selTitles.filter(item => item !== newRec)
                : [...prevState.selTitles, newRec];
            return { selTitles: updatedList };
        });
    }

    toggleCreator = (list, newRec) => {
        this.setState(prevState => {
            const updatedList = prevState.selCreators.includes(newRec)
                ? prevState.selCreators.filter(item => item !== newRec)
                : [...prevState.selCreators, newRec];
            return { selCreators: updatedList };
        });
    }
    setTab = (event, newVal) => {
        let infoVis = "tabHidden";
        let eventsVis = "tabHidden";
        let activityVis = "tabHidden";
        let postSecVis = "tabHidden";
        let academicVis = "tabHidden";
        let notesVis = "tabHidden";
        let progressVis = "tabHidden";
        switch (newVal) {
            case 0:

                infoVis = "tabVisible";

                break;
            case 1:
                eventsVis = "tabVisible";
                break;
            case 2:
                activityVis = "tabVisible";
                break;
            case 3:
                postSecVis = "tabVisible";
                break;
            case 4:
                academicVis = "tabVisible";
                break;
            case 5:
                notesVis = "tabVisible";
                break;
            case 6:
                progressVis = "tabVisible";
                break;

            default:

                break;


        }

        this.setState({ tab: newVal, infoVis: infoVis, eventsVis: eventsVis, activityVis: activityVis, postSecVis: postSecVis, academicVis: academicVis, notesVis: notesVis, progressVis });
    }
    doActivitySearch = () => {
        const { activity, selTitles, selCreators, searchText } = this.state;
        let filteredActivities = activity;
        // Extract selected titles for filtering
        const selectedTitles = selTitles.map(item => item.title);

        // Filter activity list based on selected titles
        if (selectedTitles.length > 0) {
            filteredActivities = filteredActivities.filter(act => selectedTitles.includes(act.title));
        }
        const selectedCreators = selCreators.map(item => item.creator);


        if (selectedCreators.length > 0) {
            //console.log(selectedCreators)
            filteredActivities = filteredActivities.filter(act => selectedCreators.includes(act.creator));
        }
        if (searchText.length > 0) {
            filteredActivities = filteredActivities.filter(act =>
                act.description.toLowerCase().includes(searchText.toLowerCase())
            );
            
        }

        this.setState({ activityFiltered: filteredActivities });
    }
        

canReassign = () => {
    const b = this.context && this.context.myBasics ? this.context.myBasics : {};
    return !!(b.isSupervisor || b.isAdmin || b.isStaff);
};

reloadProfile = async () => {
    const prof = await getStudentById(this.props.match.params.id);
    this.setState({ activeProfile: prof.data.result });
};

openReassign = async () => {
    this.setState({ reassignOpen: true, reassignAdvisor: null, reassignReason: "" });
    if (this.state.advisorPickerList.length === 0 && this.context.myBasics && this.context.myBasics.userProfileId) {
        try {
            const advCall = await getAdvisorListForPicker(this.context.myBasics.userProfileId);
            const advisorPickerList = (advCall.data.result || []).sort((a, b) =>
                (a.displayName || "").localeCompare(b.displayName || ""));
            this.setState({ advisorPickerList });
        } catch (err) {
            // leave list empty; user can retry
        }
    }
};

closeReassign = () => {
    this.setState({ reassignOpen: false, reassignAdvisor: null, reassignReason: "" });
};

// The caseload rows carry the coach resolved when the list was first fetched, so changing the
// assignment here leaves the Coach column stale until the caseload is reloaded. Deliberately not
// awaited: the caseload is thousands of rows and the profile page has already updated.
refreshCaseloadCoaches = () => {
    if (this.context && typeof this.context.refreshCases === "function") {
        this.context.refreshCases();
    }
};

saveReassign = async () => {
    if (!this.state.reassignAdvisor) {
        toast.warn("Please select a coach.");
        return;
    }
    this.setState({ reassignSaving: true });
    try {
        await overrideStudentAdvisor({
            userProfileId: this.props.match.params.id,
            advisorUserProfileId: this.state.reassignAdvisor.userProfileId,
            reason: this.state.reassignReason
        });
        await this.reloadProfile();
        this.setState({ reassignOpen: false, reassignAdvisor: null, reassignReason: "" });
        toast.success("Coach reassigned.");
        this.refreshCaseloadCoaches();
    } catch (err) {
        toast.error("Could not reassign coach.");
    } finally {
        this.setState({ reassignSaving: false });
    }
};

returnToAuto = async () => {
    this.setState({ reassignSaving: true });
    try {
        await clearStudentAdvisorOverride({ userProfileId: this.props.match.params.id });
        await this.reloadProfile();
        toast.success("Returned to auto-assignment.");
        this.refreshCaseloadCoaches();
    } catch (err) {
        toast.error("Could not clear the override.");
    } finally {
        this.setState({ reassignSaving: false });
    }
};

renderAssignedAdvisor = () => {
    const profile = this.state.activeProfile || {};
    const advisor = profile.advisor;
    const override = profile.advisorOverride;
    const advisorName = advisor && advisor.id && advisor.id !== '00000000-0000-0000-0000-000000000000'
        ? `${advisor.firstName || ""} ${advisor.lastName || ""}`.trim()
        : "Unassigned";

    return (
        <Grid item xs={12}>
            <Typography variant="h7" color="secondary" gutterBottom>
                Assigned Coach
            </Typography>
            <div style={{ marginTop: "6px", display: "flex", alignItems: "center", flexWrap: "wrap", gap: "10px" }}>
                <span style={{ fontWeight: 600 }}>{advisorName || "Unassigned"}</span>
                {profile.isAdvisorOverridden ? (
                    <span
                        style={{
                            display: "inline-block",
                            padding: "2px 10px",
                            borderRadius: "12px",
                            backgroundColor: "#e2a331",
                            color: "#fff",
                            fontSize: "12px",
                            fontWeight: 600,
                        }}
                    >
                        Manual override
                    </span>
                ) : null}
                {this.canReassign() ? (
                    <Button
                        size="small"
                        onClick={this.openReassign}
                        disabled={this.state.reassignSaving}
                        className="profileActionButton"
                    >
                        Reassign
                    </Button>
                ) : null}
                {this.canReassign() && profile.isAdvisorOverridden ? (
                    <Button
                        size="small"
                        onClick={this.returnToAuto}
                        disabled={this.state.reassignSaving}
                    >
                        Return to auto-assignment
                    </Button>
                ) : null}
            </div>
            {profile.isAdvisorOverridden && override ? (
                <div style={{ marginTop: "6px", fontSize: "13px", color: "#555" }}>
                    Manually assigned{override.assignedByName ? ` by ${override.assignedByName}` : ""}
                    {override.assignedDate ? ` on ${moment(override.assignedDate).format("M/D/YY")}` : ""}
                    {override.reason ? ` — Reason: ${override.reason}` : ""}
                </div>
            ) : null}
        </Grid>
    );
};

renderReassignDialog = () => {
    return (
        <Dialog open={this.state.reassignOpen} onClose={this.closeReassign} fullWidth maxWidth="sm">
            <DialogTitle>Reassign Coach</DialogTitle>
            <DialogContent>
                <div style={{ marginTop: "8px" }}>
                    <Autocomplete
                        options={this.state.advisorPickerList}
                        getOptionLabel={(o) => o.displayName || `${o.firstName || ""} ${o.lastName || ""}`.trim()}
                        isOptionEqualToValue={(o, v) => o.userProfileId === v.userProfileId}
                        value={this.state.reassignAdvisor}
                        onChange={(e, val) => this.setState({ reassignAdvisor: val })}
                        renderInput={(params) => (
                            <MuiTextField {...params} label="Search coach by name" variant="outlined" />
                        )}
                    />
                </div>
                <div style={{ marginTop: "16px" }}>
                    <MuiTextField
                        fullWidth
                        multiline
                        minRows={2}
                        label="Reason (optional)"
                        variant="outlined"
                        value={this.state.reassignReason}
                        onChange={(e) => this.setState({ reassignReason: e.target.value })}
                    />
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={this.closeReassign} disabled={this.state.reassignSaving}>Cancel</Button>
                <Button onClick={this.saveReassign} disabled={this.state.reassignSaving} className="profileActionButton">
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};

renderCrusaderId = () => {



    if (!this.state.activeProfile.studentProfile.nonOnwardStudent) {
        return (
            <span  >

                {this.state.activeProfile.studentProfile.crusaderId}

            </span>
        );
    } else {
        return (
            <span  >

                {this.state.activeProfile.studentProfile.crusaderId} - Non Program Student <AccountCircleIcon style={{ color: '#e2a331' }} />

            </span>
        );
    }

};

renderSpecialGroups = () => {
    const groups = this.state.specialGroups || [];
    if (groups.length === 0) {
        return <span style={{ color: "#777", fontStyle: "italic" }}>None</span>;
    }

    return (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
            {groups.map((group) => (
                <span
                    key={group.id}
                    style={{
                        display: "inline-block",
                        padding: "2px 10px",
                        borderRadius: "12px",
                        backgroundColor: group.isActive ? "#123225" : "#cccccc",
                        color: group.isActive ? "#fff" : "#555",
                        fontSize: "13px",
                        fontWeight: 600,
                    }}
                >
                    {group.name}{!group.isActive ? " (inactive)" : ""}
                </span>
            ))}
        </div>
    );
};

render() {
    if (!this.state.profileLoaded) {

        return <LoadingIndicator loading />;

    }
   // console.log(this);

    return (

        <div className="container">
            {this.renderReassignDialog()}
            <Link
                className={"dashboardLink"} onClick={this.props.goBack}
            >
                &lt; Back
            </Link> <br />


            <Grid container spacing={2}>


                {this.state.activeProfile
                    ? <Grid item xs={8}>
                        <Typography variant="h6">
                            {this.state.activeProfile.userProfile.firstName} {this.state.activeProfile.userProfile.lastName} -  {this.renderCrusaderId()}
                        </Typography><br />
                        Status: {enumHelper.getDisplayName(StudentStatus, this.state.activeProfile.studentProfile.status)}
                    </Grid> : null}

                <Grid item xs={4}>
                    <Typography variant="h6">
                        Family
                    </Typography>
                    <Typography variant="body1">
                        Prefered Languange: {this.getLanguage(this.state.activeProfile.family.primaryLanguage) == "Other" ? this.state.activeProfile.family.otherLanguage : this.getLanguage(this.state.activeProfile.family.primaryLanguage)}
                    </Typography>  <br />
                    {this.state.activeProfile.family.primaryParent.id != '00000000-0000-0000-0000-000000000000' ? <Link
                        className={"dashboardLink"} onClick={() => this.props.openProfile(this.state.activeProfile, "PrimaryParent")}
                    >
                        Primary Guardian: {this.state.activeProfile.family.primaryParent.firstName} {this.state.activeProfile.family.primaryParent.lastName}
                    </Link> : null}<br />
                    {this.state.activeProfile.family.secondaryParent.id != '00000000-0000-0000-0000-000000000000' ? <Link
                        className={"dashboardLink"} onClick={() => this.props.openProfile(this.state.activeProfile, "SecondaryParent")}
                    >
                        Secondary Guardian: {this.state.activeProfile.family.secondaryParent.firstName} {this.state.activeProfile.family.secondaryParent.lastName}
                    </Link> : null}<br />
                </Grid>


                <Grid item xs={12}>
                    <Tabs
                        value={this.state.tab}
                        onChange={this.setTab}
                        variant="fullWidth"
                        sx={{
                            '.MuiTabs-flexContainer': {
                                justifyContent: 'space-evenly',
                            },
                            '.MuiTab-root': {
                                border: '1px solid #000',
                                borderBottom: 'none',
                                borderTopLeftRadius: '10px',
                                borderTopRightRadius: '10px',
                                marginRight: '4px',
                                '&:last-child': {
                                    marginRight: 0,
                                },
                                '&.Mui-selected': {
                                    backgroundColor: '#123225',
                                    color: '#fff',
                                },
                                '&:hover': {
                                    backgroundColor: '#123225',
                                    color: '#fff',
                                    opacity: 1,
                                },
                            },
                        }}
                    >
                        <Tab label="INFO" />
                        <Tab label="EVENTS" />
                        <Tab label="ACTIVITIES" />
                        <Tab label="POST-SECONDARY" />
                        <Tab label="ACADEMICS" />
                        <Tab label="NOTES" />
                        <Tab label="PROGRESS" />
                    </Tabs>
                </Grid>
                <Grid container spacing={2} className={this.state.infoVis}>
                    <Grid item xs={12}>
                        <Typography variant="h5" color="secondary" >
                            General Information

                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="h7" color="secondary" gutterBottom>
                            Total Hours: {this.state.activeProfile.studentContactInfo.eventHours + this.state.activeProfile.studentContactInfo.advisorHours + this.state.activeProfile.studentContactInfo.parentHours} (Event Hours: {this.state.activeProfile.studentContactInfo.eventHours}, Coach Hours: {this.state.activeProfile.studentContactInfo.advisorHours}, Parent Hours: {this.state.activeProfile.studentContactInfo.parentHours } )
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="h7" color="secondary" gutterBottom>
                            Special Groups
                        </Typography>
                        <div style={{ marginTop: "6px" }}>
                            {this.renderSpecialGroups()}
                        </div>
                    </Grid>
                    {this.renderAssignedAdvisor()}
                    <Grid item xs={12}>
                        <GeneralInfoForm profile={this.state.activeProfile} id={this.props.match.params.id} type={"Student"} />
                    </Grid>
                </Grid>
                <Grid container spacing={2} className={this.state.eventsVis}>
                    <Grid item xs={12}>
                        <Typography variant="h5" color="secondary" gutterBottom>
                            Events

                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="h7" color="secondary" gutterBottom>
                            Total Event Hours: {this.state.activeProfile.studentContactInfo.eventHours}
                        </Typography></Grid>
                    <Grid item xs={12}>
                        <EventsList data={this.state.events} openEvent={this.props.openEvent} />
                    </Grid>
                </Grid>
                <Grid container spacing={2} className={this.state.activityVis}>
                    <Grid item xs={12}>
                        <Typography variant="h5" color="secondary" gutterBottom>
                            Activities

                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="h7" color="secondary" gutterBottom>
                            Total Coach Hours: {this.state.activeProfile.studentContactInfo.advisorHours}

                        </Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <Button onClick={() => this.props.newEntry(this.state.activeProfile)} className="profileActionButton">Add Entry</Button>
                    </Grid>

                    <Grid container spacing={2} xs={8}>
                        <Grid item xs={12}>
                            <Typography variant="h6">Search</Typography>
                        </Grid>
                        <Grid item xs={10}>
                            <Multiselect
                                fullWidth
                                options={this.state.titleList}
                                showCheckbox={true}
                                onSelect={this.toggleTitle}
                                onRemove={this.toggleTitle}
                                selectedValues={this.state.selTitles}
                                displayValue="title"
                                className="AdvisorLogsStudents"
                                avoidHighlightFirstOption={true}
                                showArrow={false}
                                placeholder="Select Tags"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <Button variant="contained" color="primary" onClick={this.doActivitySearch}>SEARCH</Button>
                        </Grid>
                        <Grid item xs={10}>
                            <Multiselect
                                fullWidth
                                options={this.state.creators}
                                showCheckbox={true}
                                onSelect={this.toggleCreator}
                                onRemove={this.toggleCreator}
                                selectedValues={this.state.selCreators}
                                displayValue="creator"
                                className="AdvisorLogsStudents"
                                avoidHighlightFirstOption={true}
                                showArrow={false}
                                placeholder="Select Creator"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <Reporting data={this.state.activityFiltered}
                                preSelected={preSelectedReportFields}
                                label="EXPORT" doNotExport={skippedFields} className="headerActionButton" />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                placeholder="Enter term to search for"
                                variant="outlined"
                                value={this.state.searchText}
                                onChange={(e) => this.setState({ searchText: e.target.value })}
                            />
                        </Grid>

                    </Grid>

                    <Grid item xs={2}>
                        <Button onClick={() => this.props.onContactAttempt(this.state.activeProfile)} className="profileActionButton">Communication Attempt</Button>
                    </Grid>
                    <Grid item xs={12}>
                        <ActivitiesList openEntry={this.props.openEntry} data={this.state.activityFiltered} message={this.state.messages} chat={this.state.chats } openMessageEntry={this.props.openMessageEntry} user={this.state.activeProfile } />
                    </Grid>
                </Grid>
                <Grid container spacing={2} className={this.state.postSecVis}>
                    <Grid item xs={12}>
                        <Typography variant="h5" color="secondary" gutterBottom>
                            Post-secondary

                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <StudentProfileFormPs student={this.state.activeProfile} ipedName={this.state.ipedName} onUpdate={updateStudentProfile} docApi={docApi } />
                        <PostSecondary />
                    </Grid>
                </Grid>
                <Grid container spacing={2} className={this.state.academicVis}>
                    <Grid item xs={12}>
                        <Typography variant="h5" color="secondary" gutterBottom>
                            Academics

                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <StudentProfileForm student={this.state.activeProfile} onUpdate={updateStudentProfile} />
                        <Academics student={this.state.activeProfile} />
                    </Grid>
                </Grid>
                <Grid container spacing={2} className={this.state.notesVis}>
                    <Grid item xs={12}>
                        <Typography variant="h5" color="secondary" gutterBottom>
                            Notes

                        </Typography>
                        <br />
                        <Button onClick={() => this.props.newNote(this.state.activeProfile)} className="profileActionButton">Add Note</Button>
                        <Notes data={this.state.notes} openNote={this.props.openNote} />
                    </Grid>
                </Grid>
                <Grid container spacing={2} className={this.state.progressVis}>
                    <Grid item xs={11}>
                        <Typography variant="h5" color="secondary" gutterBottom>
                            Progress

                        </Typography>
                        <Progress profile={this.state.activeProfile} />
                    </Grid><Grid item xs={1}>
                        <br />
                        <br />
                        <Export2PDF fileName={this.state.exportTitle}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}> <Typography variant="h4" style={{ textAlign: "center", }} >
                                    Progress
                                </Typography></Grid>
                                <Grid item xs={9}>
                                    <Typography variant="h6">
                                        &nbsp; {this.state.activeProfile.userProfile.firstName} {this.state.activeProfile.userProfile.lastName} -  {this.renderCrusaderId()}
                                    </Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    {moment(Date.now()).format("M/D/YY")}
                                </Grid>
                                <Grid item xs={12}>
                                    <Progress2Exp profile={this.state.activeProfile} />
                                </Grid>
                            </Grid>
                        </Export2PDF>
                    </Grid>
                </Grid>
            </Grid>




        </div>);
}

}
export default AdvisorStudent;